/*
  720 — Kayıtlı sepet / Geçmiş siparişlerim  (v61, 2026-09-07)
  Eşi: snippets/720-kayitli-sepet.liquid  ·  sunucu: sepet-proxy/app.py  ·  karar: ACIK-ISLER.md § E.7.13

  Kurallar:
   - Liste Liquid'den gelir (data-tt-sepetler); sunucu yalnız kaydet/sil için aranır.
   - Geri yükleme /cart/add.js ile KALEM KALEM, properties[Birim] + properties[_adim] (E.1).
   - Bayinin yazdığı her metin textContent ile basılır; innerHTML'e yalnız sabit şablon gider.
*/
(function () {
  'use strict';

  var HATA_METNI = {
    imza: 'İstek doğrulanamadı, sayfayı yenileyip tekrar deneyin.',
    zaman: 'Sayfa uzun süre açık kaldı, yenileyip tekrar deneyin.',
    giris: 'Oturumunuz kapanmış görünüyor, lütfen tekrar giriş yapın.',
    json: 'İstek biçimi hatalı.',
    baslik: 'İstek biçimi hatalı.',
    ad: 'Sepet adı 1-60 karakter olmalı.',
    satir: 'Sepet boş ya da 200 kalemden fazla.',
    tavan: 'En fazla 20 kayıtlı sepet tutabilirsiniz. Eskilerden birini silin.',
    yok: 'Bu sepet artık yok.',
    sinir: 'Çok sık istek gönderildi, biraz bekleyin.',
    sunucu: 'Sunucuya ulaşılamadı, biraz sonra tekrar deneyin.'
  };

  function metin(el, s) { el.textContent = s == null ? '' : String(s); }

  function tarihYaz(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  function jsonOku(s) {
    try { return JSON.parse(s); } catch (e) { return null; }
  }

  function veriCoz(d) {
    // Metafield json: Liquid bazen nesne, bazen dize döndürür — ikisini de kabul et
    if (typeof d === 'string') d = jsonOku(d);
    if (!d || typeof d !== 'object' || !Array.isArray(d.s)) return null;
    return d;
  }

  function toplamAdet(satirlar) {
    return satirlar.reduce(function (t, s) { return t + (parseInt(s.q, 10) || 0); }, 0);
  }

  function kur(kok) {
    if (kok.dataset.ttKuruldu) return;
    kok.dataset.ttKuruldu = '1';
    if (kok.dataset.ttGirisli !== '1') return; // girişsiz: yalnız giriş bağlantısı var

    var yer = kok.dataset.ttYer;
    var proxy = kok.dataset.ttProxy || '/apps/sepetler';
    var sepetUrl = kok.dataset.ttSepetUrl || '/cart';
    var sepetSayfasi = yer !== 'sayfa'; // 'sepet' ve 'bos' → pencere; 'sayfa' → gömülü panel

    var sepetler = (jsonOku(kok.dataset.ttSepetler) || []).map(function (k) {
      var d = veriCoz(k.d);
      return d ? { id: k.id, ad: d.ad || '(isimsiz)', t: d.t || '', s: d.s } : null;
    }).filter(Boolean).sort(function (a, b) { return (b.t || '').localeCompare(a.t || ''); });

    var siparisler = (jsonOku(kok.dataset.ttSiparisler) || []).filter(function (o) {
      return o && Array.isArray(o.s) && o.s.length;
    });

    var q = function (sel) { return kok.querySelector(sel); };
    var perde = q('[data-tt-perde]');
    var alt = q('[data-tt-alt]');
    var baslik = q('[data-tt-baslik]');
    var sekmeler = q('[data-tt-sekmeler]');
    var calisiyor = false;
    var aktifSekme = 'sepetler';

    // ---------------------------------------------------------------- görünüm
    function goster(ad) {
      kok.querySelectorAll('[data-tt-gorunum]').forEach(function (g) { g.hidden = g.dataset.ttGorunum !== ad; });
      sekmeler.hidden = ad !== 'liste';
      alt.innerHTML = '';
    }

    function dugme(yazi, sinif, tik) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'button ' + (sinif || '');
      metin(b, yazi);
      b.addEventListener('click', tik);
      alt.appendChild(b);
      return b;
    }

    function baglanti(yazi, href) {
      var a = document.createElement('a');
      a.className = 'button';
      a.href = href;
      metin(a, yazi);
      alt.appendChild(a);
      return a;
    }

    function ac() {
      if (sepetSayfasi) {
        perde.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      metin(baslik, 'Kayıtlı sepetlerim');
      listeGoster();
    }

    function kapat() {
      if (calisiyor) return;
      if (sepetSayfasi) {
        perde.hidden = true;
        document.body.style.overflow = '';
        if (kok.dataset.ttYenile === '1') location.reload();
      } else {
        listeGoster();
      }
    }

    function listeGoster() {
      goster('liste');
      sekmeSec(aktifSekme);
      if (sepetSayfasi) dugme('Kapat', 'button--secondary', kapat);
    }

    function sekmeSec(ad) {
      aktifSekme = ad;
      kok.querySelectorAll('[data-tt-sekme]').forEach(function (b) {
        b.classList.toggle('is-aktif', b.dataset.ttSekme === ad);
      });
      kok.querySelectorAll('[data-tt-panel]').forEach(function (p) { p.hidden = p.dataset.ttPanel !== ad; });
      if (ad === 'sepetler') sepetleriBas(); else siparisleriBas();
    }

    // ---------------------------------------------------------------- listeler
    function eylem(yazi, sinif, tik) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tt-ks__mini ' + (sinif || '');
      metin(b, yazi);
      b.addEventListener('click', tik);
      return b;
    }

    function satirKutusu(ad, meta) {
      var sol = document.createElement('div');
      var a = document.createElement('span');
      a.className = 'tt-ks__ad';
      metin(a, ad);
      var m = document.createElement('span');
      m.className = 'tt-ks__meta';
      metin(m, meta);
      sol.appendChild(a);
      sol.appendChild(m);
      return sol;
    }

    function sepetleriBas() {
      var ul = q('[data-tt-liste-sepetler]');
      ul.innerHTML = '';
      q('[data-tt-bos-sepetler]').hidden = sepetler.length > 0;
      sepetler.forEach(function (sp) {
        var li = document.createElement('li');
        var meta = sp.s.length + ' kalem · ' + toplamAdet(sp.s) + ' adet' + (sp.t ? ' · ' + tarihYaz(sp.t) : '');
        li.appendChild(satirKutusu(sp.ad, meta));
        var ey = document.createElement('div');
        ey.className = 'tt-ks__eylemler';
        ey.appendChild(eylem('Sepete yükle', 'tt-ks__mini--ana', function () { onizle(sp); }));
        ey.appendChild(eylem('Sil', 'tt-ks__mini--sil', function () { sil(sp, ey); }));
        li.appendChild(ey);
        ul.appendChild(li);
      });
    }

    function siparisleriBas() {
      var ul = q('[data-tt-liste-siparisler]');
      ul.innerHTML = '';
      q('[data-tt-bos-siparisler]').hidden = siparisler.length > 0;
      siparisler.forEach(function (o) {
        var li = document.createElement('li');
        var meta = o.s.length + ' kalem · ' + toplamAdet(o.s) + ' adet' + (o.t ? ' · ' + tarihYaz(o.t) : '') + (o.toplam ? ' · ' + o.toplam : '');
        li.appendChild(satirKutusu('Sipariş ' + o.ad, meta));
        var ey = document.createElement('div');
        ey.className = 'tt-ks__eylemler';
        ey.appendChild(eylem('Tekrar sepete ekle', 'tt-ks__mini--ana', function () { onizle({ ad: 'Sipariş ' + o.ad, s: o.s }); }));
        li.appendChild(ey);
        ul.appendChild(li);
      });
    }

    // ---------------------------------------------------------------- sunucu
    function istek(yol, govde) {
      return fetch(proxy + yol, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-TT-Sepet': '1' },
        body: JSON.stringify(govde)
      }).then(function (r) {
        return r.json().catch(function () { return { ok: false, hata: 'sunucu' }; }).then(function (d) {
          if (r.ok && d && d.ok) return d;
          return { ok: false, hata: (d && d.hata) || 'sunucu' };
        });
      }).catch(function () { return { ok: false, hata: 'sunucu' }; });
    }

    function hataMetni(kod) { return HATA_METNI[kod] || HATA_METNI.sunucu; }

    // ---------------------------------------------------------------- kaydet
    function sepetiOku() {
      return fetch(sepetUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    }

    function kaydetAc() {
      if (calisiyor) return;
      if (sepetSayfasi) { perde.hidden = false; document.body.style.overflow = 'hidden'; }
      metin(baslik, 'Sepeti kaydet');
      goster('kaydet');
      var ozet = q('[data-tt-kaydet-ozet]');
      var hataEl = q('[data-tt-kaydet-hata]');
      var girdi = q('[data-tt-ad]');
      hataEl.hidden = true;
      girdi.value = '';
      metin(ozet, 'Sepet okunuyor…');
      dugme('İptal', 'button--secondary', function () { kok.dataset.ttYenile = '0'; kapat(); });
      var kaydetBtn = dugme('Kaydet', '', function () {});
      kaydetBtn.disabled = true;

      sepetiOku().then(function (sepet) {
        var satirlar = (sepet.items || []).map(function (it) {
          var p = it.properties || {};
          var s = { v: it.variant_id, q: it.quantity, n: it.product_title + (it.variant_title ? ' — ' + it.variant_title : '') };
          if (p.Birim === 'Koli' || p.Birim === 'Box') s.b = p.Birim;
          var a = parseInt(p._adim, 10);
          if (a > 0) s.a = a;
          return s;
        });
        if (!satirlar.length) {
          metin(ozet, 'Sepetiniz boş, kaydedilecek bir şey yok.');
          return;
        }
        metin(ozet, satirlar.length + ' kalem, ' + toplamAdet(satirlar) + ' adet kaydedilecek.');
        kaydetBtn.disabled = false;
        girdi.focus();

        function gonder() {
          var ad = girdi.value.replace(/\s+/g, ' ').trim();
          if (!ad) { metin(hataEl, HATA_METNI.ad); hataEl.hidden = false; girdi.focus(); return; }
          calisiyor = true;
          kaydetBtn.disabled = true;
          metin(kaydetBtn, 'Kaydediliyor…');
          istek('/kaydet', { ad: ad, s: satirlar }).then(function (d) {
            calisiyor = false;
            if (!d.ok) {
              metin(hataEl, hataMetni(d.hata));
              hataEl.hidden = false;
              kaydetBtn.disabled = false;
              metin(kaydetBtn, 'Kaydet');
              return;
            }
            sepetler.unshift({ id: d.id, ad: ad, t: d.t, s: satirlar });
            kok.dataset.ttYenile = '0';
            metin(baslik, 'Kayıtlı sepetlerim');
            goster('sonuc');
            var sonuc = q('[data-tt-gorunum="sonuc"]');
            sonuc.innerHTML = '<p class="tt-ks__ozet"></p><p class="tt-ks__not">Kayıtlı sepetlerinize her cihazdan, hesabınızla ulaşabilirsiniz.</p>';
            metin(sonuc.querySelector('.tt-ks__ozet'), '"' + ad + '" kaydedildi (' + satirlar.length + ' kalem).');
            dugme('Kayıtlı sepetlerim', 'button--secondary', function () { aktifSekme = 'sepetler'; listeGoster(); });
            dugme('Kapat', '', kapat);
          });
        }
        kaydetBtn.addEventListener('click', gonder);
        girdi.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); gonder(); } });
      }).catch(function () {
        metin(ozet, 'Sepet okunamadı, sayfayı yenileyip tekrar deneyin.');
      });
    }

    // ---------------------------------------------------------------- sil
    function sil(sp, ey) {
      if (calisiyor) return;
      if (!window.confirm('"' + sp.ad + '" silinsin mi?')) return;
      var btns = ey.querySelectorAll('button');
      btns.forEach(function (b) { b.disabled = true; });
      calisiyor = true;
      istek('/sil', { id: sp.id }).then(function (d) {
        calisiyor = false;
        if (!d.ok) {
          btns.forEach(function (b) { b.disabled = false; });
          window.alert(hataMetni(d.hata));
          return;
        }
        sepetler = sepetler.filter(function (x) { return x.id !== sp.id; });
        sepetleriBas();
      });
    }

    // ---------------------------------------------------------------- geri yükle
    function onizle(kaynak) {
      if (calisiyor) return;
      metin(baslik, 'Sepete yükle');
      goster('onizleme');
      metin(q('[data-tt-onizleme-ozet]'), '"' + kaynak.ad + '" — ' + kaynak.s.length + ' kalem, ' + toplamAdet(kaynak.s) + ' adet.');
      var ul = q('[data-tt-onizleme-liste]');
      ul.innerHTML = '';
      kaynak.s.forEach(function (s) {
        var li = document.createElement('li');
        var sol = document.createElement('span');
        metin(sol, s.n || ('Ürün #' + s.v));
        if (s.b) {
          var em = document.createElement('span');
          em.className = 'tt-ks__birim';
          metin(em, ' · ' + s.b);
          sol.appendChild(em);
        }
        var sag = document.createElement('span');
        sag.className = 'tt-ks__adet';
        metin(sag, s.q + ' adet');
        li.appendChild(sol);
        li.appendChild(sag);
        ul.appendChild(li);
      });
      var secim = q('[data-tt-secim]');
      secim.hidden = true;

      dugme('Geri', 'button--secondary', listeGoster);
      var ekleBtn = dugme('Sepete ekle', '', function () { basla(kaynak, false); });

      sepetiOku().then(function (sepet) {
        if (sepet && sepet.item_count > 0) {
          metin(q('[data-tt-mevcut-adet]'), sepet.item_count);
          secim.hidden = false;
          var degistir = dugme('Sepeti değiştir', 'button--secondary', function () { basla(kaynak, true); });
          alt.insertBefore(degistir, ekleBtn);
          metin(ekleBtn, 'Mevcut sepete ekle');
        }
      }).catch(function () { /* sepet okunamadıysa seçenek gösterilmez, ekleme yine çalışır */ });
    }

    function kalemEkle(s) {
      var props = {};
      if (s.b) props.Birim = s.b;
      if (s.a) props._adim = String(s.a);
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: s.v, quantity: s.q, properties: props }] })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (g) {
          if (r.ok) return { ok: true };
          return { ok: false, mesaj: (g && (g.description || g.message)) || 'eklenemedi' };
        });
      }).catch(function () { return { ok: false, mesaj: 'bağlantı hatası' }; });
    }

    function basla(kaynak, bosalt) {
      if (calisiyor) return;
      calisiyor = true;
      goster('ilerleme');
      var ilerlemeTx = q('[data-tt-ilerleme-metin]');
      var bar = q('[data-tt-bar]');
      var eklenen = 0, eksikler = [];
      var sira = Promise.resolve();

      if (bosalt) {
        sira = sira.then(function () {
          metin(ilerlemeTx, 'Mevcut sepet boşaltılıyor…');
          return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } });
        });
      }

      kaynak.s.forEach(function (s, i) {
        sira = sira.then(function () {
          metin(ilerlemeTx, 'Ekleniyor… ' + (i + 1) + ' / ' + kaynak.s.length);
          bar.style.width = Math.round((i / kaynak.s.length) * 100) + '%';
          return kalemEkle(s).then(function (r) {
            if (r.ok) eklenen++;
            else eksikler.push({ ad: s.n || ('Ürün #' + s.v), mesaj: r.mesaj });
          });
        });
      });

      sira.then(function () {
        bar.style.width = '100%';
        calisiyor = false;
        kok.dataset.ttYenile = eklenen > 0 || bosalt ? '1' : '0';
        goster('sonuc');
        var sonuc = q('[data-tt-gorunum="sonuc"]');
        sonuc.innerHTML = '<p class="tt-ks__ozet"></p>';
        metin(sonuc.querySelector('.tt-ks__ozet'), eklenen + ' kalem sepete eklendi.');
        if (eksikler.length) {
          var kutu = document.createElement('div');
          kutu.className = 'tt-ks__eksik';
          var st = document.createElement('strong');
          metin(st, eksikler.length + ' kalem eklenemedi:');
          kutu.appendChild(st);
          var ul = document.createElement('ul');
          eksikler.forEach(function (e) {
            var li = document.createElement('li');
            metin(li, e.ad + ' — ' + e.mesaj);
            ul.appendChild(li);
          });
          kutu.appendChild(ul);
          sonuc.appendChild(kutu);
        }
        dugme(sepetSayfasi ? 'Kapat' : 'Geri', 'button--secondary', function () {
          if (sepetSayfasi) kapat(); else listeGoster();
        });
        if (eklenen > 0) baglanti('Sepete git', sepetUrl);
      });
    }

    // ---------------------------------------------------------------- bağla
    var acBtn = q('[data-tt-ac]');
    if (acBtn) acBtn.addEventListener('click', ac);
    var kaydetAcBtn = q('[data-tt-kaydet-ac]');
    if (kaydetAcBtn) kaydetAcBtn.addEventListener('click', kaydetAc);
    kok.querySelectorAll('[data-tt-kapat]').forEach(function (b) { b.addEventListener('click', kapat); });
    kok.querySelectorAll('[data-tt-sekme]').forEach(function (b) {
      b.addEventListener('click', function () { sekmeSec(b.dataset.ttSekme); });
    });
    if (sepetSayfasi) {
      perde.addEventListener('click', function (e) { if (e.target === perde) kapat(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !perde.hidden) kapat(); });
      if (location.hash === '#kayitli-sepetler') ac();
    } else {
      listeGoster();
    }
  }

  function baslat() { document.querySelectorAll('[data-tt-ks]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
